import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Popover from "@material-ui/core/Popover";
import Typography from "@material-ui/core/Typography";
import { Badge, Grid, IconButton, List } from "@material-ui/core";
import { createStyles } from "@mui/material";
import { Notifications, NotificationsOff } from "@material-ui/icons";
import TaskNotification from "../NotificationTypes/TaskNotification";

const useStyles = makeStyles((theme) => ({
  typography: {
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  noNotificationTypography: {
    padding: theme.spacing(2),
  },
  notifIcons: {
    padding: "0px 7px 0px 7px !important",
    color: "#FFF",
    cursor: "hand",
  },
  popover: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  notificationList: {
    overflowY: "auto",
    maxHeight: "300px",
  }
}));

const StyledBadge = withStyles((theme) =>
  createStyles({
    badge: {
      top: 13,
      border: `2px solid ${theme.palette.background.paper}`,
      padding: "0 4px",
    },
  })
)(Badge);

export default function NotificationsPopover({
  notificationsArray,
  setNotifications,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationUpdate = (updatedNotif) => {
    setNotifications(
      notificationsArray.map((notif) =>
        notif.uuid === updatedNotif.uuid ? { ...notif, seen: true } : notif
      )
    );
  };

  const NotificationType = ({ notification }) => {
    switch (notification.type) {
      case 1:
        return (
          <TaskNotification
            notif={notification}
            onUpdate={handleNotificationUpdate}
          />
        );
      default:
        return;
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? "notifications-popover" : undefined;

  return (
    <div>
      <IconButton
        aria-describedby={id}
        className={classes.notifIcons}
        aria-label="notifications"
        onClick={handleClick}
      >
        <StyledBadge
          badgeContent={
            notificationsArray.filter((notification) => !notification.seen)
              .length
          }
          color="secondary"
          overlap="rectangular"
        >
          <Notifications />
        </StyledBadge>
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className={classes.popover}>
          {notificationsArray.length === 0 ? (
            <Typography className={classes.noNotificationTypography}>
              <Grid container spacing={2}>
                <Grid item>
                  <NotificationsOff />
                </Grid>
                <Grid item>Aucune notification disponible</Grid>
              </Grid>
            </Typography>
          ) : (
            <>
              <Typography className={classes.typography}>
                <Grid container spacing={2}>
                  <Grid item>
                    <Notifications />
                  </Grid>
                  <Grid item>Notifications</Grid>
                </Grid>
              </Typography>
              <List className={classes.notificationList}>
                {notificationsArray.map((notif) => (
                  <NotificationType key={notif.uuid} notification={notif} />
                ))}
              </List>
            </>
          )}
        </div>
      </Popover>
    </div>
  );
}
